import pricePayload from "@/payloads/price.json";
import refChangesPayload from "@/payloads/ref_changes.json";
import refFieldsPayload from "@/payloads/ref_fields.json";
import corporateActionsReferencePayload from "@/payloads/corporate_actions_reference.json";
import corporateActionsReferenceChangesPayload from "@/payloads/corporate_actions_reference_changes.json";
import corporateActionsEventsPayload from "@/payloads/corporate_actions_events.json";

export default {
  dismissNotification() {
    const notification = document.querySelector("ef-notification-tray");
    if (notification !== null) {
      const parent = notification.parentElement;
      const html = document.querySelector("html");
      parent.removeChild(notification);
      html.style.removeProperty("padding-top");
      html.style.removeProperty("box-sizing");
    }
  },
  mainLayoutToggleButtonClicked() {
    this.$refs.mainLayout.collapsed = !this.$refs.mainLayout.collapsed;
    this.$refs.mainLayoutToggleButton.setAttribute(
      "icon",
      this.$refs.mainLayout.collapsed ? "leftpanel-closed" : "leftpanel-open"
    );
  },
  closePopup() {
    this.$refs.instrumentDialog.opened = false;
  },
  switchTab(event) {
    console.log("switch", event.target.label);
    switch (event.target.label.toLowerCase()) {
      case "reference":
        this.refChangesFlag = false;
        this.referenceActive = true;
        this.corporateActionsActive = false;
        this.pricingActive = false;
        this.$nextTick(() => {
          if (this.rowClickFlag[1] == 0) {
            this.refChangesFlag = true;
            this.rowClickFlag[1] = 1;
            this.refFieldsFlag = false;
            this.priceChartFlag = false;
            this.requestType = "reference";
            var payload = JSON.parse(JSON.stringify(refFieldsPayload));
            payload["dataConditions"]["conditions"][0]["fieldValue"] =
              this.selectedRIC;
            payload["dateConditions"][0]["startDate"] = this.selectedDate;
            payload["dateConditions"][0]["endDate"] = this.todayDate;
            var payload2 = JSON.parse(JSON.stringify(refChangesPayload));
            payload2["dataConditions"]["conditions"][0]["fieldValue"] =
              this.selectedRIC;
            payload2["dataConditions"]["conditions"][1]["fieldValue"] =
              this.selectedRIC;
            payload2["dateConditions"][0]["startDate"] = this.selectedDate;
            payload2["dateConditions"][0]["endDate"] = this.todayDate;
            this.refPromise = 2;
            Promise.all([
              this.postQueryExecution(payload),
              this.postQueryExecution(payload2),
            ]);
          } else {
            this.refChangesFlag = true;
            setTimeout(() => this.renderCachedReferenceGrid(), 500);
          }
        });
        break;
      case "corporate actions":
        this.referenceActive = false;
        this.corporateActionsActive = true;
        this.pricingActive = false;
        this.$nextTick(() => {
          this.renderCorporateActionsReferenceChangesGrid();
          this.switchCorporateActionsTab({
            target: {
              label: "Reference",
            },
          });
        });
        break;
      case "pricing":
        this.refChangesFlag = false;
        this.referenceActive = false;
        this.corporateActionsActive = false;
        this.pricingActive = true;
        if (!this.priceChartFlag) {
          this.priceChartFlag = true;
        }
        this.$nextTick(async () => {
          if (this.rowClickFlag[2] == 0) {
            this.rowClickFlag[2] = 1;
            this.requestType = "pricing";
            var payload = JSON.parse(JSON.stringify(pricePayload));
            const end = new Date();
            end.setDate(end.getDate() - 2);
            const start = new Date();
            start.setDate(start.getDate() - 11);
            payload["dataConditions"]["conditions"][0]["fieldValue"] =
              this.selectedQuotePermId;
            payload["dateConditions"][0]["startDate"] = start
              .toJSON()
              .slice(0, 10);
            payload["dateConditions"][0]["endDate"] = end.toJSON().slice(0, 10);
            var payload2 = JSON.parse(JSON.stringify(pricePayload));
            const end2 = new Date();
            end2.setDate(end2.getDate() - 12);
            const start2 = new Date();
            start2.setDate(start2.getDate() - 21);
            payload2["dataConditions"]["conditions"][0]["fieldValue"] =
              this.selectedQuotePermId;
            payload2["dateConditions"][0]["startDate"] = start2
              .toJSON()
              .slice(0, 10);
            payload2["dateConditions"][0]["endDate"] = end2
              .toJSON()
              .slice(0, 10);
            this.promiseFlag = 2;
            Promise.all([
              this.postQueryExecution(payload),
              this.postQueryExecution(payload2),
            ]);
          } else {
            setTimeout(() => this.renderPricingGrid(), 500);
          }
        });
        break;
    }
  },
  switchCorporateActionsTab(event) {
    switch (event.target.label.toLowerCase()) {
      case "reference":
        this.activateCorporateActionsReference();
        break;
      case "events":
        this.activateCorporateActionsEvents();
        break;
    }
  },

  activateCorporateActionsReference() {
    this.requestType = "corporate actions reference";
    this.corporateActionsReferenceActive = true;
    this.corporateActionsEventsActive = false;
    this.equityCorporateActionsReferenceFields = [];
    this.equityCorporateActionsReferenceEventFields = [];
    this.equityCorporateActionsReferenceFieldChanges = [];
    this.renderCorporateActionsReferenceEventsGrid();
    this.renderCorporateActionsReferenceChangesGrid();
    this.$nextTick(() => {
      if (this.rowClickFlag[3] == 0) {
        this.rowClickFlag[3] = 1;
        this.rowClickFlag[4] = 0;
      }

      this.executeCorporateActionsQuery([
        corporateActionsReferencePayload,
        corporateActionsReferenceChangesPayload,
      ]);

      this.renderCorporateActionsReferenceEventsGrid();
      this.renderCorporateActionsReferenceChangesGrid();
    });
  },

  activateCorporateActionsEvents() {
    this.requestType = "corporate actions events";
    this.corporateActionsReferenceActive = false;
    this.corporateActionsEventsActive = true;

    this.equityCorporateActionsEventItems = [];
    this.renderCorporateActionsEventsGrid();
    this.$nextTick(() => {
      console.log(this.rowClickFlag, this.rowClickFlag[4]);
      if (this.rowClickFlag[4] == 0) {
        this.rowClickFlag[3] = 0;
        this.rowClickFlag[4] = 1;
        this.executeCorporateActionsQuery([corporateActionsEventsPayload]);
      }
      this.renderCorporateActionsEventsGrid();
    });
  },

  executeCorporateActionsQuery(payloadTemplates) {
    const payloads = payloadTemplates.map((payloadTemplate) => {
      const payload = JSON.parse(JSON.stringify(payloadTemplate));

      for (let i = 0; i < payload["dateConditions"].length; i++) {
        console.log("Setting date conditions for index:", i);
        payload["dateConditions"][i]["startDate"] = this.selectedDate;
        payload["dateConditions"][i]["endDate"] = this.todayDate;
      }

      const fieldValueMappings = {
        instrument_id: this.selectedIssuePermId,
        underlying_quote_id: this.selectedQuotePermId,
      };

      for (const [fieldName, mappedValue] of Object.entries(fieldValueMappings)) {
        const condition = payload["dataConditions"]["conditions"].find(
          (conditionItem) => conditionItem.fieldName === fieldName
        );
        if (condition) {
          condition.fieldValue = mappedValue;
        }
      }
      return payload;
    });

    Promise.all(payloads.map((payload) => this.postQueryExecution(payload)));
  },
};
